import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppStoreButton from './AppStoreButton';
import BoneSketch from './BoneSketch';
import './AppPage.css';

export default function AppPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app-page" style={{ position: 'relative', minHeight: '100vh' }}>
      <BoneSketch />
      
      <header className="app-page-header" style={{ position: 'relative', zIndex: 1 }}>
        <div className="container">
          <Link to="/" className="back-link">
            ← Back to Home
          </Link>
        </div>
      </header>

      <main className="app-page-main" style={{ position: 'relative', zIndex: 1 }}>
        <div className="container">
          <div className="app-page-content">
            <div className="app-page-logo-container">
              <img 
                src={require('./assets/images/fixed-logo-1024.png')} 
                alt="Yuppy logo" 
                className="app-page-logo" 
              />
              <h1>Yuppy</h1>
            </div>

            <AppStoreButton isAppPage={true} />
          </div>
        </div>
      </main>
    </div>
  );
} 